import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import PageTitle from '../components/PageTitle';
import { AdBannerResponsive } from '../components/GoogleAdsense';
import ProductCarousel from '../components/affiliate/ProductCarousel';
import '../styles/tsumugi-faq.css';

const FaqPage = () => {
  const navigate = useNavigate();
  const [openItems, setOpenItems] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');

  useEffect(() => {
    document.title = 'よくあるご質問 | つむぎ';
  }, []);

  const toggleItem = (itemId) => {
    setOpenItems(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const faqData = [
    {
      category: "橋本病と食事について",
      categoryId: "hashimoto",
      icon: "🏥",
      items: [
        {
          id: "hashimoto-1",
          question: "昆布だしやわかめは食べても大丈夫ですか？",
          answer: "昆布は少量でもヨウ素が非常に多いため避けてください。わかめ・海苔・寒天は適量なら問題ありません。昆布だしは使用を控え、かつおだしや煮干しだしをおすすめします。根昆布療法やヨウ素系うがい薬も避けましょう。"
        },
        {
          id: "hashimoto-2",
          question: "体重管理に悩んでいます",
          answer: "橋本病の方の中には体重管理にお悩みの方が多くいらっしゃいます。体重の変化については必ず医師にご相談ください。当サービスでは、医師の指導のもと、代謝を考慮したビタミンB群やミネラルを意識した食事提案を行います。過度なカロリー制限ではなく、バランスの良い栄養摂取をサポートします。"
        },
        {
          id: "hashimoto-3",
          question: "サプリメントは飲んでもいいですか？",
          answer: "セレン・亜鉛・ビタミンB群などは甲状腺ホルモン合成に必要ですが、自己判断での摂取は避けてください。ヨウ素サプリは特に危険です。必ず医師に相談の上、つむぎの相談機能で個別化されたサプリメント戦略を受け取ることをおすすめします。"
        },
        {
          id: "hashimoto-4",
          question: "ヨウ素制限の食事を作るのが面倒です",
          answer: "冷蔵庫レシピ生成機能をご利用ください。冷蔵庫の写真を撮るだけで、ヨウ素制限に配慮したレシピを自動生成します。プロフィールでアレルギー・避けたい食材（昆布など）を登録すれば、すべての提案で自動的に除外されます。"
        }
      ]
    },
    {
      category: "サービス・機能について",
      categoryId: "service",
      icon: "🎯",
      items: [
        {
          id: "service-1",
          question: "つむぎとは何ですか？",
          answer: "橋本病（甲状腺機能低下症）の方向けの栄養・疲労管理をサポートするAIサービスです。ヨウ素制限・疲労回復・体重管理など、橋本病特有の悩みに対応した食事提案を提供します。栄養パートナー『つむぎ』があなたに寄り添い、医師の治療を食事面からサポートします。"
        },
        {
          id: "service-2",
          question: "医師の診断や治療の代わりになりますか？",
          answer: "いいえ。本サービスは栄養面での補助ツールです。診断・治療・薬の調整は必ず医師にご相談ください。当サービスは医師の治療を食生活の面からサポートし、日常の食事の悩みを解決することを目的としています。"
        },
        {
          id: "service-3",
          question: "血液検査の結果をつむぎに見せても大丈夫ですか？",
          answer: "はい。Standard プラン以上では血液検査OCR機能で、TSH・FT4などの検査値を自動認識し、栄養相談に活用します。データは暗号化され安全に保存されます。ただし、検査結果の医学的な解釈は必ず医師に確認してください。"
        },
        {
          id: "service-4",
          question: "つむぎチャットと相談機能の違いは何ですか？",
          answer: "相談機能（📝相談）は詳細な情報を入力して包括的な栄養アドバイスを受ける機能です。つむぎチャット（💬チャット）は気軽な質問や、気持ちを聞いてほしい時に使える共感型の機能です。つむぎは頑張りを強要せず、「今のままでいいんだよ」という安心感を提供します。"
        },
        {
          id: "service-5",
          question: "利用制限はありますか？",
          answer: "各機能の利用にはポイントを消費します（つむぎチャット1pt、栄養相談4pt、レシピ4ptなど）。月間ポイントはプランごとに異なり、毎月リセットされます。日次の利用回数制限はありません。"
        }
      ]
    },
    {
      category: "料金・プラン制限について",
      categoryId: "plan",
      icon: "💰",
      items: [
        {
          id: "plan-1",
          question: "無料プランで十分ですか？有料にするべきですか？",
          answer: "Freeプラン（月50ポイント）で橋本病の基本的な食事指導は十分受けられます。\n\n有料プランがおすすめな方：\n• 毎日栄養相談したい → Standard（¥480/月、900pt）\n• 全機能をフル活用したい → Premium（¥980/月、1,800pt）\n\nすべてのプランで日次の利用制限はありません。月間ポイントの範囲内で自由にご利用いただけます。"
        },
        {
          id: "plan-2",
          question: "各プランの具体的な違いは何ですか？",
          answer: "【Free（無料）】月50pt｜つむぎチャット・栄養相談・レシピ生成をお試し\n\n【Standard（¥480/月）】月900pt｜毎日の相談やレシピ生成を日常的に。血液検査分析も利用可能\n\n【Premium（¥980/月）】月1,800pt｜全機能フル活用。会話履歴永久保存、月次AIレポート\n\n【Premium Plus（¥1,980/月）】月3,600pt｜さらに充実した利用量\n\n【Ultimate（¥2,980/月）】月5,500pt｜最上級の利用量\n\nすべてのプランで日次制限はありません。"
        },
        {
          id: "plan-3",
          question: "プラン変更はいつでもできますか？日割り計算されますか？",
          answer: "はい、いつでも変更可能です。アップグレード時は即座に反映され、ダウングレード時は次回請求日から適用されます。日割り計算はありませんので、アップグレードは月初がお得です。解約もいつでも可能で、違約金はありません。"
        },
        {
          id: "plan-4",
          question: "支払い方法は何がありますか？",
          answer: "クレジットカード決済（Visa、MasterCard、JCB、American Express、Diners Club）に対応しています。決済処理にはPay.JP（ペイジェーピー）を使用し、カード情報は当サービスで保持せず安全に決済されます。"
        },
        {
          id: "plan-5",
          question: "つむぎチャットの制限回数を教えてください",
          answer: "つむぎチャットに1日あたりの回数制限はありません。\n\n各プランの月間ポイントの範囲内で、好きなだけお話しいただけます。\n• Free: 月50pt（つむぎチャット1pt/回）\n• Standard: 月900pt\n• Premium: 月1,800pt\n• Premium Plus: 月3,600pt\n• Ultimate: 月5,500pt"
        }
      ]
    },
    {
      category: "アカウント・セキュリティ",
      categoryId: "account",
      icon: "🔐",
      items: [
        {
          id: "account-1",
          question: "パスワードを忘れてしまいました",
          answer: "ログイン画面の「パスワードをお忘れですか？」リンクから、パスワードリセットのメールを送信できます。メールに記載されたリンクをクリックして、新しいパスワードを設定してください。メールが届かない場合は、迷惑メールフォルダもご確認ください。"
        },
        {
          id: "account-2",
          question: "メールアドレスを変更したいです",
          answer: "マイページ > プロフィール編集 から、メールアドレスを変更できます。新しいメールアドレスに確認メールが送信されますので、リンクをクリックして変更を完了してください。変更完了まで、元のメールアドレスでログインできます。"
        },
        {
          id: "account-3",
          question: "個人情報は安全に管理されていますか？",
          answer: "はい。すべての通信はSSL/TLS暗号化で保護され、個人情報・血液検査データ・相談内容は厳重に管理されています。医療機関との共有や第三者への提供は一切行いません。詳しくはプライバシーポリシーをご確認ください。"
        },
        {
          id: "account-4",
          question: "会員登録時にメール認証が必要ですか？",
          answer: "はい。登録時に送信される認証メールのリンクをクリックして、メールアドレスの確認が必要です。認証完了後、すべての機能をご利用いただけます。メールが届かない場合は、迷惑メールフォルダもご確認ください。"
        },
        {
          id: "account-5",
          question: "アカウントを削除したいです",
          answer: "マイページの「アカウント削除」から手続きできます。削除後、相談履歴・レシピ・気分記録などすべてのデータが完全に削除され、復元できません。有料プランご利用中の方は、先にプラン解約をお願いします。"
        }
      ]
    },
    {
      category: "相談・使い方",
      categoryId: "usage",
      icon: "📱",
      items: [
        {
          id: "usage-1",
          question: "相談履歴はどこで見られますか？",
          answer: "画面下部の固定ナビゲーション（ログイン後のみ表示）から「👤 マイページ」をタップすると、最近の相談履歴が表示されます。また、右上のハンバーガーメニュー（☰）→「📋 相談履歴」から、過去のすべての相談を確認できます。"
        },
        {
          id: "usage-2",
          question: "どのような相談ができますか？",
          answer: "橋本病に関する栄養・食事の悩みに対応します：\n\n• ヨウ素制限食の献立提案\n• 体重管理・むくみ対策の食事サポート\n• 疲労回復のための栄養バランス\n• 血液検査データを考慮した栄養相談（Standard以上）※検査結果の医学的解釈は医師にご確認ください\n• 食事面でのサプリメント検討サポート\n• 季節・体調に合わせた7日分レシピ（Premium）"
        },
        {
          id: "usage-3",
          question: "継続相談・追加質問はできますか？",
          answer: "はい。相談履歴から前回の内容を確認でき、フォーム相談・チャットどちらでも追加質問できます。チャットでは「前回の相談の〇〇について」と聞くと、文脈を考慮した回答が得られます。履歴の保存期間はプランによって異なります（Free: 3日、Standard: 30日、Premium以上: 無期限）。"
        },
        {
          id: "usage-4",
          question: "ハンバーガーメニュー（☰）から何ができますか？",
          answer: "画面右上のハンバーガーメニューから以下にアクセスできます：\n\n【ログイン後】マイページ、プロフィール編集、プラン変更、相談履歴、保存レシピ、FAQ、使い方ガイド、ログアウト\n\n【ログイン前】ログイン、新規登録、FAQ、使い方ガイド"
        },
        {
          id: "usage-5",
          question: "相談機能（📝）とチャット（💬）の使い分けは？",
          answer: "【相談機能（📝相談）】詳細な情報（体調・目標・生活習慣）を入力して、包括的な栄養アドバイス・献立提案を受けたい時に使います。\n\n【つむぎチャット（💬チャット）】ちょっとした質問、追加確認、気持ちを聞いてほしい時に使います。つむぎは頑張りを強要せず、共感してくれます。\n\nどちらも各プランの月間ポイントの範囲内で使えます。冷蔵庫レシピ・チラシレシピともに1回10ptです。"
        },
        {
          id: "usage-6",
          question: "「今ある食材でレシピ」の使い方を教えてください",
          answer: "レシピハブページから「今ある食材でレシピ」を選択し、冷蔵庫の写真をアップロードまたは食材を選択してください。つむぎが食材を認識し、ヨウ素制限に配慮したレシピを自動生成します。プロフィールに登録したアレルギー・苦手な食材も自動で除外されます。冷蔵庫レシピは1回10ptです。各プランの月間ポイントの範囲内でご利用いただけます（例：Freeプラン50ptなら月5回分）。"
        }
      ]
    },
    {
      category: "レシピ・食事提案",
      categoryId: "recipe",
      icon: "🍽️",
      items: [
        {
          id: "recipe-1",
          question: "アレルギー・食べられないものがある場合は？",
          answer: "右上のハンバーガーメニュー（☰）→「⚙️ プロフィール編集」でアレルギー情報・苦手な食材を登録してください。すべてのレシピ提案・AI相談でその情報が自動的に考慮されます。昆布・海藻類もここで登録できます。後から追加・変更も可能です。"
        },
        {
          id: "recipe-2",
          question: "家族分のレシピも教えてもらえますか？",
          answer: "はい。相談時に「家族2人分」「4人家族向け」などと人数を明記してください。Standard以上のプランでは、家族構成に合わせた量・コスト調整も可能です。Premium プランでは、家族全員分の7日間献立も提案できます。"
        },
        {
          id: "recipe-3",
          question: "季節や旬の食材を考慮してくれますか？",
          answer: "はい。つむぎは現在の季節や旬の食材を自動的に考慮してレシピを提案します。また、「旬の食材を使った春のレシピ」「夏バテ対策の冷たいメニュー」などと具体的にリクエストすることも可能です。"
        },
        {
          id: "recipe-4",
          question: "提案されたレシピを保存できますか？",
          answer: "はい。各レシピ提案の下部に「💾 レシピを保存」ボタンがあります。保存したレシピは、画面下部の固定ナビゲーション「📚 レシピ」、または右上メニュー「📚 保存レシピ」からいつでも確認できます。"
        },
        {
          id: "recipe-5",
          question: "レシピを家族や医師と共有できますか？",
          answer: "保存したレシピの詳細ページから、PDF出力やスクリーンショット共有が可能です（今後のアップデートで、メール送信・LINE共有機能も追加予定）。血液検査結果と合わせて医師に見せることもできます。"
        }
      ]
    }
  ];

  // フィルタリング処理
  const filteredFaqData = faqData
    .map(category => ({
      ...category,
      items: category.items.filter(item => {
        const matchesSearch = searchQuery === '' ||
          item.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.answer.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesCategory = activeCategory === 'all' || category.categoryId === activeCategory;
        return matchesSearch && matchesCategory;
      })
    }))
    .filter(category => category.items.length > 0);

  return (
    <AppLayout>
      <PageTitle
        title="よくあるご質問"
        subtitle="FAQ"
        icon="❓"
      />

      <div className="tsumugi-container faq-page">
        {/* 検索バー */}
        <div className="faq-search-section">
          <div className="faq-search-box">
            <span className="faq-search-icon">🔍</span>
            <input
              type="text"
              className="faq-search-input"
              placeholder="質問を検索..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            {searchQuery && (
              <button
                className="faq-search-clear"
                onClick={() => setSearchQuery('')}
              >
                ✕
              </button>
            )}
          </div>
        </div>

        {/* カテゴリタブ */}
        <div className="faq-category-tabs">
          <button
            className={`faq-category-tab ${activeCategory === 'all' ? 'faq-category-tab--active' : ''}`}
            onClick={() => setActiveCategory('all')}
          >
            すべて
          </button>
          {faqData.map(category => (
            <button
              key={category.categoryId}
              className={`faq-category-tab ${activeCategory === category.categoryId ? 'faq-category-tab--active' : ''}`}
              onClick={() => setActiveCategory(category.categoryId)}
            >
              <span className="faq-category-icon">{category.icon}</span>
              <span className="faq-category-label">{category.category}</span>
            </button>
          ))}
        </div>

        {/* FAQ項目 */}
        <div className="faq-content">
          {filteredFaqData.length === 0 ? (
            <div className="faq-no-results">
              <p className="faq-no-results__text">
                「{searchQuery}」に関する質問が見つかりませんでした
              </p>
              <button
                className="faq-no-results__button"
                onClick={() => setSearchQuery('')}
              >
                検索をクリア
              </button>
            </div>
          ) : (
            filteredFaqData.map(category => (
              <div key={category.categoryId} className="faq-category-section">
                <h2 className="faq-category-title">
                  <span className="faq-category-title__icon">{category.icon}</span>
                  <span className="faq-category-title__text">{category.category}</span>
                </h2>

                <div className="faq-items">
                  {category.items.map(item => (
                    <div
                      key={item.id}
                      className={`faq-item ${openItems[item.id] ? 'faq-item--open' : ''}`}
                    >
                      <button
                        className="faq-item__header"
                        onClick={() => toggleItem(item.id)}
                      >
                        <span className="faq-item__question">
                          Q. {item.question}
                        </span>
                        <span className="faq-item__toggle">
                          {openItems[item.id] ? '−' : '+'}
                        </span>
                      </button>

                      {openItems[item.id] && (
                        <div className="faq-item__answer">
                          <p className="faq-item__answer-text">
                            A. {item.answer.split('\n').map((line, idx) => (
                              <React.Fragment key={idx}>
                                {line}
                                {idx < item.answer.split('\n').length - 1 && <br />}
                              </React.Fragment>
                            ))}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))
          )}
        </div>

        {/* 追加サポート */}
        <div className="faq-support-section">
          <div className="faq-support-card">
            <h3 className="faq-support-title">
              解決しない場合は
            </h3>
            <p className="faq-support-text">
              上記で解決しない場合は、チャット機能でお気軽にお問い合わせください。
            </p>
            <button
              className="faq-support-button"
              onClick={() => navigate('/chat')}
            >
              💬 チャットで質問する
            </button>
          </div>
        </div>

        <AdBannerResponsive />
        <ProductCarousel location="faq" />

        {/* 最終更新日 */}
        <p className="faq-last-updated">
          最終更新日: 2026年1月
        </p>
      </div>
    </AppLayout>
  );
};

export default FaqPage;
